const reserveSiteDetail = () =>
  import('@/views/main/reserve/site/cpns/site-detail/site-detail.vue')
export default {
  path: '/main/reserve/reserveSiteDetail',
  name: 'reserveSiteDetail',
  component: reserveSiteDetail,
  children: []
}
